import GoogleMapsApi from '../classes/GoogleMapsApi'   // quiet

export default class Contact {
    constructor() {

    }

    init() {
        //console.log("contact initialised");
    }

    contact() {
        //console.log("contact contact initialised");
    }

    finalize() {
        //console.log("contact finalized");
    }

    initGmap() {
        const gmapApi = new GoogleMapsApi()
        gmapApi.load().then(() => {
            const el = document.getElementById('gMap');
            if(el){
                const lat = 40.282918,
                      lng = 28.944222,
                      mapoptions = {zoom:15};

                gmapApi.renderMap(el,mapoptions,{lat,lng},[{lat,lng}]);
            }
        });
    }
}